import { error } from '@sveltejs/kit';
import { dev } from '$app/environment';

// export const prerender = true;
export async function load({ params, parent }) {
	const { storyblokApi } = await parent();
	const slug = params.slug;
	let path = 'cdn/stories/feature/';
	if (slug) {
		path += slug;
	} else {
		path += 'home';
	}

	try {
		const dataStory = await storyblokApi.get(path, {
			version: dev ? 'draft' : 'published',
			resolve_relations: 'footer'
		});

		return {
			story: dataStory.data.story
		};
	} catch (err) {
		throw error(err.status, err.response);
	}
}
